import React from 'react';
import * as S from './UserInfoHeader.styles';
import { SkeletonLoader } from '@/components/SkeletonLoader/SkeletonLoader';

export const UserInfoHeaderSkeleton = () => {
  return (
    <S.Container>
      <S.Content>
        <S.AvatarBox>
          <SkeletonLoader width="100%" height="100%" borderRadius={18} />
        </S.AvatarBox>

        <S.InfoBlock>
          <S.UserInfo>
            <SkeletonLoader width={116} height={26} borderRadius={7} />
            <SkeletonLoader width={90} height={15} borderRadius={7} />
          </S.UserInfo>

          <S.Badges>
            <SkeletonLoader width={170} height={32} borderRadius={16} />
            <SkeletonLoader width={165} height={32} borderRadius={16} />
          </S.Badges>
        </S.InfoBlock>
      </S.Content>
    </S.Container>
  );
};
